import { DataBean } from "../DataBean";

export class OutputAuthorizationRequest extends DataBean {

  public async getOutputAuthorizationRequestCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getOutputAuthorizationRequestCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getOutputAuthorizationRequestRender(page: number, rows: number, properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getOutputAuthorizationRequestRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async getOutputAuthorizationRequest(idoutputauthorizationrequest: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.OutputAuthorizationRequest_getOutputAuthorizationRequest_Number",
      [idoutputauthorizationrequest]
    );
  }

  public async deleteOutputAuthorizationRequest(idoutputauthorizationrequest: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteOutputAuthorizationRequest_Number",
      [idoutputauthorizationrequest]
    );
  }

  public async getPdfSalidaAlmacen(idEmployee: number, idoutputauthorizationrequest: number): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.bean.filemanagement.FileMap_getPdfSalidaAlmacen_Number_Number",
      [idEmployee, idoutputauthorizationrequest]
    );
  }

  public async updateOutputAuthorizationRequest(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.OutputAuthorizationRequest_updateOutputAuthorizationRequest_com.orange.finance.processcontract.bean.OutputAuthorizationRequest",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.OutputAuthorizationRequest",
        },
      ]
    );
  }
}
